
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getOrderInit, createOrder } from '@/api/order';
import { getDepartmentList } from '@/api/company';
import { UserModule } from '../../store/modules/user';
import { addOrderServerIsHave, addOrderServerIsMust, checkPermissionUseAndCompany ,addOrderNotShow } from '@/utils/permission';
import { makeKey, getAvinfo } from '@/utils/qiniu';
//服务部门选择
import SelectDepartment from '../../components/DeptDialog/index.vue';
import OrderTag from './components/OrderTag.vue';
import OrderArea from './components/OrderArea.vue';
import OrderAddress from './components/OrderAddress.vue';
import OrderAddressCustom from './components/OrderAddressCustom.vue';
import OrderBrand from './components/OrderBrand.vue';
import OrderDevice from '@/components/DeviceSelectDialog/index.vue';
import { Type } from '../../types/permissionType';
import dialogImgLarge from '@/components/ImgLarge/index.vue';
import BenzAMRRecorder from 'benz-amr-recorder';
import DialogSetImport from '../staff/components/setImport.vue';
import DialogLveReportDept from '@/components/DeptLev/index.vue';
import OrderNotice from './components/OrderNotice.vue';
import SelectFaultDialog from '@/components/SelectFaultDialog/index.vue';

@Component({
  name: 'orderAdd',
  components: {
    SelectDepartment,
    OrderTag,
    OrderAddress,
    OrderAddressCustom,
    OrderArea,
    OrderBrand,
    OrderDevice,
    dialogImgLarge,
    DialogSetImport,
    DialogLveReportDept,
    OrderNotice,
    SelectFaultDialog
  }
})

export default class extends Vue {
  @Watch('servicer', {
    deep: true,
    immediate: false
  })
  private servicerChange(newVal:any) {
    if (!newVal) {
      this.isShowTag = false;
      this.isShowFaultType = false;
      this.isShowProduct = false;
      this.isShowCusDept = false;
      this.isShowSerDept = false;
      this.isShowAppointment = false;
      this.isShowPic = false;
      this.isShowSound = false;
      this.isShowAddressPca = false;
      this.isShowAddressSelf = false;
      this.isShowDevice = false;
      this.isShowVideo = false;
      this.isShowDiyOne = false;
      this.isShowDiyTwo = false;
      this.isShowWordFile = false;

      this.isShowAddress = true;
      this.isShowContentUser = true;
      this.isShowContentUserMobile = true;
      this.isShowContentUserPhone = true;
      this.isShowDescription = true;
      return;
    }
    if (newVal && !newVal.fix_module) {
      this.showErrorMsg('此公司暂不提供维修业务');
      return;
    }

    if (newVal.repair_prompt && newVal.repair_prompt.title) {
      this.noticeVisible = true;
      this.noticeData = newVal.repair_prompt;
      this.noticeData.serNum = this.serListOptions.length;
    }
    this.serDrptOptions = newVal.dept_list;
    this.isShowTag = addOrderServerIsHave(Type.tag, 2, newVal);
    this.isShowFaultType = addOrderServerIsHave(Type.FAULT_PHENOMENON, 2, newVal);
    this.isShowProduct = addOrderServerIsHave(Type.product, 2, newVal);
    //增加报修部门显示
    this.isShowCusDept = !addOrderNotShow(Type.CUS_DEPT, 2, newVal);
    this.isShowSerDept = addOrderServerIsHave(Type.dept, 2, newVal);
    this.isShowAppointment = addOrderServerIsHave(Type.time, 2, newVal);
    this.isShowPic = addOrderServerIsHave(Type.photo, 2, newVal);
    this.isShowSound = addOrderServerIsHave(Type.sound, 2, newVal);
    this.isShowAddressPca = addOrderServerIsHave(Type.pca, 2, newVal);
    this.isShowAddressSelf = addOrderServerIsHave(Type.myselfPCALs, 2, newVal);
    this.isShowAddress = addOrderServerIsHave(Type.address, 2, newVal);
    this.isShowDevice = addOrderServerIsHave(Type.device, 2, newVal);
    this.isShowDeviceSN = addOrderServerIsHave(Type.SN, 2, newVal);
    this.isShowVideo = addOrderServerIsHave(Type.video, 2, newVal);

    this.isShowContentUser = addOrderServerIsHave(Type.contentUser, 2, newVal);
    this.isShowContentUserMobile = addOrderServerIsHave(Type.contentUserMobile, 2, newVal);
    this.isShowContentUserPhone = addOrderServerIsHave(Type.contentUserPhone, 2, newVal);
    this.isShowDescription = addOrderServerIsHave(Type.Description, 2, newVal);

    this.isShowDiyOne = addOrderServerIsHave(Type.DiyOne, 2, newVal);
    this.isShowDiyTwo = addOrderServerIsHave(Type.DiyTwo, 2, newVal);

    this.isShowWordFile = addOrderServerIsHave(Type.WordFile, 2, newVal);

    this.isMustTag = addOrderServerIsMust(Type.tag, 2, newVal);
    this.isMustFaultType = addOrderServerIsMust(Type.FAULT_PHENOMENON, 2, newVal);
    this.isMustProduct = addOrderServerIsMust(Type.product, 2, newVal);
    this.isMustCusDept = addOrderServerIsMust(Type.CUS_DEPT, 2, newVal);
    this.isMustSerDept = addOrderServerIsMust(Type.dept, 2, newVal);
    this.isMustAppointment = addOrderServerIsMust(Type.time, 2, newVal);
    this.isMustPic = addOrderServerIsMust(Type.photo, 2, newVal);
    this.isMustSound = addOrderServerIsMust(Type.sound, 2, newVal);
    this.isMustVideo = addOrderServerIsMust(Type.video, 2, newVal);
    this.isMustAddressPca = addOrderServerIsMust(Type.pca, 2, newVal);
    this.isMustAddressSelf = addOrderServerIsMust(Type.myselfPCALs, 2, newVal);
    this.isMustAddress = addOrderServerIsMust(Type.address, 2, newVal);
    this.isMustDevice = addOrderServerIsMust(Type.device, 2, newVal);
    this.isMustDeviceSN = addOrderServerIsMust(Type.SN, 2, newVal);
    this.isMustVideo = addOrderServerIsMust(Type.video, 2, newVal);

    this.isMustContentUser = addOrderServerIsMust(Type.contentUser, 2, newVal);
    this.isMustContentUserMobile = addOrderServerIsMust(Type.contentUserMobile, 2, newVal);
    this.isMustContentUserPhone = addOrderServerIsMust(Type.contentUserPhone, 2, newVal);
    this.isMustDescription = addOrderServerIsMust(Type.Description, 2, newVal);

    this.isMustDiyOne = addOrderServerIsMust(Type.DiyOne, 2, newVal);
    this.isMustDiyTwo = addOrderServerIsMust(Type.DiyTwo, 2, newVal);
    this.isMustWordFile = addOrderServerIsMust(Type.WordFile, 2, newVal);

    //如果
    if(this.isShowContentUser && !this.formAdd.name){
      this.$set(this.formAdd, 'name',  UserModule.getUserName);
    }
    if(this.isShowContentUserMobile && !this.formAdd.mobile){
      this.$set(this.formAdd, 'mobile', UserModule.getUserMobile);
    }

    // addrssType 1 省市区 3 自定义地址
    if (this.isShowAddressSelf && newVal.vip_level && parseInt(String(newVal.vip_level).substring(0, 1)) === 2) {
      this.addrssType = '3';
    }
    if (this.isShowAddressPca && newVal.vip_level && parseInt(String(newVal.vip_level).substring(0, 1)) === 3) {
      this.addrssType = '1';
    }
    // 自定义东西
    this.dropdownOptions = newVal.trouble_describle_tags_list;
    if (newVal.template_set) {
      if (newVal.template_set.order_servicer_dept_name) {
        this.placeHolderSerDept = newVal.template_set.order_servicer_dept_name;
      } else {
        this.placeHolderSerDept = '服务部门';
      }
      if (newVal.template_set.order_trouble_describe) {
        this.placeHolderDescription = newVal.template_set.order_trouble_describe;
      } else {
        this.placeHolderDescription = '任务描述';
      }
      if (newVal.template_set.order_tags_name) {
        this.placeholderTag = newVal.template_set.order_tags_name;
      } else {
        this.placeholderTag = '标签';
      }
      if (newVal.template_set.order_fault_phenomenon_name) {
        this.placeholderFaultType = newVal.template_set.order_fault_phenomenon_name;
      } else {
        this.placeholderFaultType = '故障现象';
      }
      // 目前自定义不能修改
      // if (newVal.template_set.order_brand_name) {
      //   this.placeholderProduct = newVal.template_set.order_brand_name;
      // } else {
      //   this.placeholderProduct = '品牌类型';
      // }
      if (newVal.template_set.order_mainaddress_name) {
        this.placeHolderAddress = newVal.template_set.order_mainaddress_name;
      } else {
        this.placeHolderAddress = '所在地区';
      }
      if (newVal.template_set.order_subaddress_name) {
        this.placeHolderAddressDetail = newVal.template_set.order_subaddress_name;
      } else {
        this.placeHolderAddressDetail = '地址';
      }
      if (newVal.template_set.order_customer_user_name) {
        this.reportUser = newVal.template_set.order_customer_user_name;
      } else {
        this.reportUser = '申请人';
      }
      if (newVal.template_set.order_customer_dept_name) {
        this.reportUserDept = newVal.template_set.order_customer_dept_name;
      } else {
        this.reportUserDept = '报修部门';
      }
      if (newVal.template_set.order_name) {
        this.placeHolderContentUser = newVal.template_set.order_name;
      } else {
        this.placeHolderContentUser = '联系人';
      }
      if (newVal.template_set.order_diy_one_content) {
        this.placeHolderDiyOne = newVal.template_set.order_diy_one_content;
      } else {
        this.placeHolderDiyOne = '自定义1';
      }
      if (newVal.template_set.order_diy_two_content) {
        this.placeHolderDiyTwo = newVal.template_set.order_diy_two_content;
      } else {
        this.placeHolderDiyTwo = '自定义2';
      }
      if (newVal.template_set.order_device_sn) {
        this.placeHolderDeviceSN = newVal.template_set.order_device_sn;
      } else {
        this.placeHolderDeviceSN = '设备编号';
      }
    }
  }
  private isShowTag=false;
  private isMustTag=false;

  private isShowFaultType=false;
  private isMustFaultType=false;

  private isShowProduct=false;
  private isMustProduct=false;

  private isShowDevice=false;
  private isMustDevice=false;

  private isShowDeviceSN=false;
  private isMustDeviceSN=false;

  private isShowCusDept=false;
  private isMustCusDept=false;
  private cusDeptType= 9;//9所有部门
  private cusDeptIsMulti= 1;

  private isShowSerDept=false;
  private isMustSerDept=false;

  private isShowAppointment=false;
  private isMustAppointment=false;

  private isShowPic=false;
  private isMustPic=false;
  private isShowSound=false;
  private isMustSound=false;
  private isShowVideo=false;
  private isMustVideo=false;

  private isShowAddressPca=false;
  private isMustAddressPca=false;
  private isShowAddressSelf=false;
  private isMustAddressSelf=false;

  private isMustAddress=false;

  private isShowSN=false;
  private isMustSN=false;

  private isShowDiyOne=false;
  private isMustDiyOne=false;

  private isShowDiyTwo=false;
  private isMustDiyTwo=false;

  private isShowWordFile=false;
  private isMustWordFile=false;

  // 默认显示
  private isShowAddress=true;
  private isShowContentUser=true;
  private isShowContentUserMobile=true;
  private isShowContentUserPhone=true;
  private isShowDescription=true;

  private isMustContentUser=false;
  private isMustContentUserMobile=false;
  private isMustContentUserPhone=false;
  private isMustDescription=false;

  private isShowIsSelf=false;

  private servicer:any={}
  private UserName=UserModule.getUserName
  // private userDeptList=[]
  private formAdd:any={
    name: '',
    mobile: '',
    phone_num: '',
    sendDeptName:''
  }
  private serDealDeptment=[];

  private dropdownOptions = []

  private handSelectedDescription(val: any, num: number, index: any) {
    if (num === 2) {
      let aa:any = {};
      aa.value = val.name;
      this.$set(this.dynamicDescription, index, aa);
    } else {
      this.$set(this.formAdd, 'description', val.name);
    }
  }

  // 骑牛
  private action = 'https://up-z1.qiniup.com';
  private qiuniuToken:any={}
  private qiuniuform={}
  private qiniuPicList:any=[]
  private qiniuSoundList:any=[]
  private qiniuVideoList: any = []
  private qiniuWordFileList: any = []

  private vipLevel=1;

  created() {
    if (parseInt(UserModule.getCompanyId) !== 0 && UserModule.company) {
      this.vipLevel = parseInt(
        String(UserModule.company.vip_level).substring(0, 1)
      );
      if (UserModule.company.brand_name_alias) {
        this.placeholderProduct = UserModule.company.brand_name_alias;
      } else {
        this.placeholderProduct = '品牌类型';
      }
    }

    this.isShowIsSelf = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.IsSelfTask);

    if (checkPermissionUseAndCompany(UserModule.getCompanyId, Type.ORDER_REPORT_DEPT)) {
      this.cusDeptType = 9;
      this.cusDeptIsMulti = 1;
      this.getReportDept(9);
    } else if(checkPermissionUseAndCompany(UserModule.getCompanyId, Type.REPORT_DEPT_LOOK_SUB)){
      this.cusDeptType = 6;
      this.cusDeptIsMulti = 1;
      this.getReportDept(6);
    }else{
      // let userDeptList = UserModule.getUserDeptList;
      //   if (!userDeptList || userDeptList.length < 1) {
      //     this.isHaveUserDept = false;
      //   } else if (userDeptList.length === 1) {
      //     this.isHaveUserDept = true;
      //     this.formAdd.userDeptName = userDeptList[0].name;
      //     this.formAdd.userDept = userDeptList[0];
      //   } else {
      //     this.isHaveUserDept = true;
      //   }
      this.cusDeptType = 6;
      this.cusDeptIsMulti = 0;
      this.getReportDept(6);
    }

    this.initOrder(0);

    //遍历UserModule.getUserDeptList找到dept_type=2的项
    // this.serDealDeptment = UserModule.getUserDeptList.filter((item:any) => {
    //   return parseInt(item.dept_type) === 2;
    // });
   
  }

  // 导入订单
  private setImportVisible=false
  private setImportTitle='导入订单'
  private downloadExcelHandle() {
    window.location.href = process.env.BASE_URL + 'static/frontUserNew/template/import_order.xlsx';
  }
  private customerImportorder='';
  private importOrderHandle() {
    this.setImportVisible = true;
  }
  private closeImport(val: any) {
    this.setImportVisible = val;
  }

  private isShowServicer=String((UserModule.getCompany as any).vip_level).substr(0, 1) !== '2'
  private isHaveUserDept=parseInt(UserModule.getCompanyId) !== 0
  private serListOptions:any=[]
  private serDrptOptions:any = []

  private placeholderTag:string='标签';
  private placeholderProduct:string='品牌类型';
  private placeholderFaultType:string='故障现象';
  private placeHolderSerDept:string= '服务部门';
  private placeHolderDescription:string= '任务描述';
  private placeHolderAddress:string= '所在地区';
  private placeHolderAddressDetail:string= '地址';
  private reportUser:string='申请人';
  private reportUserDept:string='报修部门';
  private placeHolderContentUser:string='联系人'
  private placeHolderDiyOne:string='自定义1'
  private placeHolderDiyTwo:string='自定义2'
  private placeHolderDeviceSN:string='设备编号'

  private address:any={}
  private addrssType:string='1';

  // 初始化
  private initOrder(type:number) {
    // type 1 =报修后再次初始化 0= 进入页面初始化
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    getOrderInit(params).then(res => {
      if (res.data) {
        if (res.data.servicer_list && res.data.servicer_list.length === 1) {
          this.servicer = res.data.servicer_list[0];
          this.serDrptOptions = res.data.servicer_list[0].dept_list;
          if (this.serDrptOptions && this.serDrptOptions.length === 1) {
            if (type === 0) {
              this.$set(this.formAdd, 'servicerDept', this.serDrptOptions[0]);
            } else {
              if (!this.formAdd.servicerDept || !this.formAdd.servicerDept.dept_id) {
                this.$set(this.formAdd, 'servicerDept', this.serDrptOptions[0]);
              }
            }
          }
        }
        this.serListOptions = res.data.servicer_list;
        if (type === 0) {
          this.address = res.data.address_default;
          if (res.data.address_default) {
            this.addressId = res.data.address_default.id;
            if (res.data.address_default.province_name) {
              this.$set(this.formAdd, 'area', res.data.address_default.province_name !== res.data.address_default.city_name
                ? res.data.address_default.province_name + '  ' + res.data.address_default.city_name + '  ' + res.data.address_default.district_name
                : res.data.address_default.province_name + '  ' + res.data.address_default.district_name);
            }
            this.provinceName = res.data.address_default.province_name;
            this.province = res.data.address_default.province;
            this.cityName = res.data.address_default.city_name;
            this.city = res.data.address_default.city;
            this.districtName = res.data.address_default.district_name;
            this.district = res.data.address_default.district;
            this.$set(this.formAdd, 'addressDetail', res.data.address_default.address);
            this.$set(this.formAdd, 'name', res.data.address_default.name);
            this.$set(this.formAdd, 'mobile', res.data.address_default.mobile);
            this.$set(this.formAdd, 'phone_num', res.data.address_default.phone_num);
          }
        }

        this.qiuniuToken = res.data.uptoken;
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }

  private handlePictureCardPreview() {

  }

  private handleRemove() {

  }
  private departmentVisible = false
  private title = '选择部门'
  private selectDeptListQuery = {}

  private selectDeptServicerHandle() {
    this.departmentVisible = true;
  }
  private closeDeptHandle(value: boolean) {
    this.departmentVisible = value;
  }
  private selectDept(value:any) {
    this.$set(this.formAdd, 'servicerDept', value);
  }
  
  // 报修部门
  private departmentLevVisible=false
  private selectReportDept() {
    this.departmentLevVisible = true;
  }
  private selectDeptLev(value:any) {
    this.formAdd.userDept = value;
  }
  private handleLveReportDeptConfirm() {
    this.departmentLevVisible = false;
    this.formAdd.userDeptName = this.formAdd.userDept.name;
  }
  private closeDialogLveReportDept() {
    this.formAdd.userDept = null;
    this.departmentLevVisible = false;
  }

  // 指派自己报修部门
  private selfDepartmentLevVisible=false
  private selectSelfDept() {
    this.selfDepartmentLevVisible = true;
  }
  private selectSelfDeptLev(value:any) {
    this.formAdd.sendDept = value;
  }
  private handleLveSelfDeptConfirm() {
    this.selfDepartmentLevVisible = false;
    this.formAdd.sendDeptName = this.formAdd.sendDept.name;
  }
  private closeDialogLveSelfDept() {
    this.formAdd.sendDept = null;
    this.formAdd.sendDeptName = '',
    this.selfDepartmentLevVisible = false;
  }
  private sendSelfTaskHandle(val:any){
    //this.selfDepartmentLevVisible = true;
    //请求部门 
      let params: any = {
        user_id:UserModule.getUserId ? UserModule.getUserId : '0',
        company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
        type: 6, // type=9 查所有部门  type=2查服务部门
        dept_type:2,
        size: 1000,
        page: 1,
        source_type: 1
      };
       getDepartmentList(params)
      .then((res) => {
        if (res.data) {
          this.serDealDeptment = res.data.list ;
          if (!res.data.list || res.data.list.length < 1) {
            console.log()
          } else if (res.data.list.length === 1) {
            this.formAdd.sendDept = res.data.list[0]
            this.formAdd.sendDeptName =  this.formAdd.sendDept.name;
          } else {
            console.log()
          }
        }else{
          console.log()
        }
      })
      .catch((err) => {
        let msg = err.msg;
      });

    // if (val && this.formAdd.isSelf && (this.serDealDeptment && this.serDealDeptment.length == 1) ) {
    //   this.formAdd.sendDept = this.serDealDeptment[0];
    // }
    // else{
    //   this.formAdd.sendDept = '';
    // }
  }
  
  // 订单标签
  private selectTagArray:any = []
  private tagVisible = false
  private selectTag() {
    if (this.servicer) {
      if (this.selectTagArray && this.selectTagArray.length >= 3) {
        this.showErrorMsg('最多只能选择3个标签');
        return;
      }
      this.tagVisible = true;
    } else {
      this.showErrorMsg('请选择服务方');
    }
  }
  private closeTagHandle(value:boolean) {
    this.tagVisible = value;
  }
  private delTagHandle(val: any) {
    this.selectTagArray.splice(this.selectTagArray.indexOf(val), 1);
  }
  private confirmTagHandle(value:any) {
    this.tagVisible = false;
    let filter = this.selectTagArray.filter((tag:any) => {
      return tag.tags_id === value.tags_id;
    });
    if (filter && filter.length > 0) {
      return;
    }
    this.selectTagArray.push(value);
    let descriptionPlaceholdera = '';
    if (this.selectTagArray && this.selectTagArray.length > 0) {
      for (let i = 0; i < this.selectTagArray.length; i++) {
        if (this.selectTagArray[i].trouble_describle_prompt) {
          descriptionPlaceholdera += (this.selectTagArray[i].trouble_describle_prompt + ';');
        }
      }
    }
    if (descriptionPlaceholdera && descriptionPlaceholdera.length > 0) {
      this.placeHolderDescription = descriptionPlaceholdera.slice(0, descriptionPlaceholdera.length - 1);
    }
  }
  // 故障类型 Phenomenon
  private faultVisible=false;
  private isPhenomenon=true;

  private selectFaultHandle(val:any) {
    this.faultVisible = true;
  }
  private comfirmSelectFault(val:any) {
    this.faultVisible = false;
    this.formAdd.faultPhenomenonParent = val.faultTypeParent;
    this.formAdd.faultPhenomenon = val.faultType;
    this.formAdd.faultPhenomenonChild = val.faultTypeChild ;
    this.formAdd.faultPhenomenonStr = this.formAdd.faultPhenomenonParent.name;
    if (this.formAdd.faultPhenomenon && this.formAdd.faultPhenomenon.id) {
      this.formAdd.faultPhenomenonStr = this.formAdd.faultPhenomenonStr + '/' + this.formAdd.faultPhenomenon.name;
      if(this.formAdd.faultPhenomenonChild && this.formAdd.faultPhenomenonChild.id){
        this.formAdd.faultPhenomenonStr = this.formAdd.faultPhenomenonStr + '/' + this.formAdd.faultPhenomenonChild.name;
      }
    }
  }
  private closeSelectFaultDialog(val:any) {
    this.faultVisible = val;
  }
  // 任务描述
  private dynamicDescription:any[] = []
  private descriptionAddHandle() {
    if (this.dynamicDescription && this.dynamicDescription.length > 3) {
      this.$alert('最多添加5条任务描述', '提示', {
        confirmButtonText: '确定'
      });
    } else {
      this.dynamicDescription.push({
        value: ''
      });
    }
  }
  private descriptionDeleteHandle(value: any) {
    // 删除新增的任务描述
    let index = this.dynamicDescription.indexOf(value);
    if (index !== -1) {
      this.dynamicDescription.splice(index, 1);
    }
  }

  // 选择省市区
  private areaVisible = false
  private provinceName=''
  private province=''
  private cityName=''
  private city=''
  private districtName=''
  private district=''
  private selectAreaHandle() {
    if (parseInt(this.addrssType) === 3) {
      this.areaCustomVisible = true;
    } else {
      this.areaVisible = true;
    }
  }
  private closeAreaHandle(value:boolean) {
    this.areaVisible = value;
  }
  private saveAreaHandle(value:any) {
    this.provinceName = value.province_name;
    this.province = value.province;
    this.cityName = value.city_name;
    this.city = value.city;
    this.districtName = value.district_name;
    this.district = value.district;
    this.formAdd.area = value.province_name !== value.city_name
      ? value.province_name + '  ' + value.city_name + '  ' + value.district_name
      : value.province_name + '  ' + value.district_name;
    this.areaVisible = false;
  }
  // 选择自定义
  private addressId=''
  private areaCustomVisible = false
  private oneAddress=''
  private oneAddressId=''
  private twoAddress=''
  private twoAddressId=''
  private threeAddress=''
  private threeAddressId=''
  private saveAreaCustomHandle(value:any) {
    this.areaCustomVisible = false;
    if (value) {
      if (value.pBean && value.pBean1) {
        this.oneAddress = JSON.parse(value.pBean).address;
        this.oneAddressId = JSON.parse(value.pBean).id;
        this.twoAddress = JSON.parse(value.pBean1).address;
        this.twoAddressId = JSON.parse(value.pBean1).id;
        this.threeAddress = value.address;
        this.threeAddressId = value.id;
      } else if (value.pBean) {
        this.oneAddress = JSON.parse(value.pBean).address;
        this.oneAddressId = JSON.parse(value.pBean).id;
        this.twoAddress = value.address;
        this.twoAddressId = value.id;
        this.threeAddress = '';
        this.threeAddressId = '0';
      } else {
        this.oneAddress = value.address;
        this.oneAddressId = value.id;
        this.twoAddress = '';
        this.twoAddressId = '0';
        this.threeAddress = '';
        this.threeAddressId = '0';
      }
    }
    this.formAdd.area = this.oneAddress + '  ' + this.twoAddress + '  ' + this.threeAddress;
  }
  private closeAreaCustomHandle(value:boolean) {
    this.areaCustomVisible = value;
  }
  // 选择地址
  private addressVisible = false
  private selectAddressHandle() {
    this.addressVisible = true;
  }
  private selectAddressConfim(val:any) {
    this.addressId = val.id;
    if (parseInt(this.addrssType) === 3) {
      // 自定义地址
      if (val.one_address_name) {
        this.formAdd.area = val.one_address_name + '  ' + val.two_address_name + '  ' + val.three_address_name;
        this.oneAddress = val.one_address_name;
        this.oneAddressId = val.one_address_id;
        this.twoAddress = val.two_address_name;
        this.twoAddressId = val.two_address_id;
        this.threeAddress = val.three_address_name;
        this.threeAddressId = val.three_address_id;
      }
    } else {
      // 省市区
      if (val.province_name) {
        this.provinceName = val.province_name;
        this.province = val.province;
        this.cityName = val.city_name;
        this.city = val.city;
        this.districtName = val.district_name;
        this.district = val.district;
        this.formAdd.area = val.province_name !== val.city_name
          ? val.province_name + '  ' + val.city_name + '  ' + val.district_name
          : val.province_name + '  ' + val.district_name;
      }
    }
    this.formAdd.addressDetail = val.address;
    this.formAdd.name = val.name;
    this.formAdd.mobile = val.mobile;
    this.formAdd.phone_num = val.phone_num;
    this.address = val;
  }
  private closeAddressHandle(value:boolean) {
    this.addressVisible = value;
  }

  // 附件

  // 品牌
  private brandVisible = false;
  private productBean:any = ''
  private selectBrandHandle() {
    this.brandVisible = true;
  }
  private confirmBrandHandle(val:any) {
    this.productBean = val;
    this.formAdd.brand = this.productBean.brand_name;
    if (this.productBean.product_name) {
      this.formAdd.brand = this.formAdd.brand + '/' + this.productBean.product_name;
    }
    if (this.productBean.model_name) {
      this.formAdd.brand = this.formAdd.brand + '/' + this.productBean.model_name;
    }
  }
  private closeBrandHandle(value: boolean) {
    this.brandVisible = value;
  }

  // 设备
  private deviceVisible = false
  private selectDevice:any = []
  private selectDeviceHandle() {
    this.deviceVisible = true;
  }

  private confirmDeviceHandle(value: any) {
    this.selectDevice = value;
  }
  private cleanDevice(val:any, index:any) {
    this.selectDevice.splice(index, 1);
  }
  private closeDeviceHandle(value: boolean) {
    this.deviceVisible = value;
  }

  // 预约时间
  private selectAppointmentHandle() {
  }
  private appointmentDayTimestamp:any=''
  private appointmentTimeInterval:any=''
  pickerChange(val:any) {
    let minite = val.slice(-2);
    let hour = val.slice(-5, -3);
    val = val.slice(0, -5);
    let minite2 = '00';
    let i = Math.ceil(parseInt(minite) / 5);
    if (i * 5 < 10) {
      minite2 = '0' + i * 5;
    } else {
      minite2 = '' + i * 5;
    }
    let data = new Date(val);
    this.appointmentDayTimestamp = data.getTime() / 1000;
    this.appointmentTimeInterval = hour + ':' + minite2;
    val = val + hour + ':' + minite2;
    this.formAdd.appointment = val;
  }
  // qiniu
  private uploadSuccess(res: any) {
    this.qiniuPicList.push(res.key);
  }
  private beforeUpload(file:any) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传图片大小不能超过 5MB!');
    }
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then(res => {
      let k = makeKey(this.qiuniuToken.prekey);
      this.qiuniuform = {
        key: k,
        token: this.qiuniuToken.uptoken,
        domain: this.qiuniuToken.domain
      };
    });
  }
  private imgLargeHandle(val: [], index: number, type: number) {
    let arr = [];
    if (type === 2) {
      let h: any = {};
      h.media_type = type;
      h.video_url = val;
      arr.push(h);
    } else {
      for (let i = 0; i < val.length; i++) {
        arr.push(this.qiuniuToken.default_url + val[i]);
      }
    }
    let enlargedData = {
      isShow: true,
      imgList: arr,
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
  private async handleUploadSuccessSound(res: any) {
    getAvinfo(this.qiuniuToken.default_url + res.key).then(avinfo => {
      if (avinfo) {
        this.qiniuSoundList.push(
          { url: res.key,
            full_path: this.qiuniuToken.default_url + res.key,
            seconds: Math.round((avinfo as any).duration),
            isPlaying: false
          }
        );
      }
    });
  }
  private beforeUploadUploadSound(file:any) {
    const isJPG = file.type === 'audio/mpeg';
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isJPG) {
      return this.$message.error('上传文件只能是 mp3 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传音频大小不能超过 5MB!');
    }
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then(res => {
      let k = makeKey(this.qiuniuToken.prekey);
      this.qiuniuform = {
        key: k,
        token: this.qiuniuToken.uptoken,
        domain: this.qiuniuToken.domain
      };
    });
  }
  private voiceHandle(val: any, index: number) {
    let _this = this;
    let amr = new BenzAMRRecorder();

    for (let i = 0; i < val.length; i++) {
      if (i === index) {
        val[i].isPlaying = true;
      }
      val[i].isPlaying = false;
    }

    amr.initWithUrl(val[index].full_path).then(function() {
      val[index].isPlaying = true;
      amr.play();
      _this.$set(val, index, val[index]);
    });

    amr.onEnded(function() {
      amr.stop();
      val[index].isPlaying = false;
      _this.$set(val, index, val[index]);
    });
  }
  private beforeUploadUploadVideo(file:any) {
    const isJPG = file.type === 'video/mp4';
    const isLt2M = file.size / 1024 / 1024 < 20;
    if (!isJPG) {
      return this.$message.error('上传文件只能是 mp4 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传视频大小不能超过 20MB!');
    }
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then(res => {
      let k = makeKey(this.qiuniuToken.prekey) + '.mp4';
      this.qiuniuform = {
        key: k,
        token: this.qiuniuToken.uptoken,
        domain: this.qiuniuToken.domain
      };
    });
  }
  private handleUploadSuccessVideo(res:any) {
    getAvinfo(this.qiuniuToken.default_url + res.key).then(avinfo => {
      if (avinfo) {
        this.qiniuVideoList.push(
          { url: res.key,
            full_path: this.qiuniuToken.default_url + res.key,
            seconds: Math.round((avinfo as any).duration),
            isPlaying: false
          }
        );
      }
    });
  }
  private uploadSuccessDocument(res:any, file:any, fileList:any) {
    this.qiniuWordFileList = fileList;
  }
  private beforeUploadDocument(file:any) {
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then(res => {
      this.qiuniuform = {
        key: makeKey(this.qiuniuToken.prekey),
        token: this.qiuniuToken.uptoken,
        domain: this.qiuniuToken.domain
      };
    });
  }
  private onExceed() {
    this.$message.error('最多上传4个文档');
  }
  private onRemove(file:any, fileList:any) {
    this.qiniuWordFileList = fileList;
  }
  private deleteImgHandle(val:any, num:number) {
    // 1 pic 2 sound 3 video
    switch (num) {
      case 1:
        for (let i = 0; i < this.qiniuPicList.length; i++) {
          if (this.qiniuPicList[i] === val) {
            this.qiniuPicList.splice(i, 1);
          }
        }
        break;
      case 2:
        for (let m = 0; m < this.qiniuSoundList.length; m++) {
          if (this.qiniuSoundList[m].url === val.url) {
            this.qiniuSoundList.splice(m, 1);
          }
        }
        break;
      case 3:
        for (let n = 0; n < this.qiniuVideoList.length; n++) {
          if (this.qiniuVideoList[n].full_path === val.full_path) {
            this.qiniuVideoList.splice(n, 1);
          }
        }
        break;
    }
  }


  private createOrder() {
    // (this.$refs.formAddref as any).$el.submit();
    if (this.servicer && this.servicer.servicer_company_id && !this.servicer.fix_module) {
      this.showErrorMsg('此公司暂不提供维修业务');
      return;
    }
    let parameters:any = {};
    // 1是自己报，2是替客户报
    parameters['order_create_type'] = '1';
    parameters['order_type'] = '2';
    parameters['address_type'] = this.addrssType;

    parameters['user_id'] = UserModule.getUserId;
    parameters['user_name'] = UserModule.getUserName;
    // TODO 缺个人身份报修

    if (parseInt(UserModule.getCompanyId) !== 0) {
      parameters['company_id'] = UserModule.getCompanyId;
      parameters['customer_company_id'] = UserModule.getCompanyId;
      parameters['customer_company_name'] = UserModule.getCompanyName;

      if ( !this.isHaveUserDept && this.isMustCusDept){
        this.showErrorMsg('请联系管理员加入'+this.reportUserDept);
        return;
      }
      if (this.isHaveUserDept && this.isMustCusDept && !(this.formAdd.userDept && this.formAdd.userDept.dept_id) ) {
        this.showErrorMsg( '请选择'+this.reportUserDept);
        return;
      }
      if (this.formAdd.userDept && this.formAdd.userDept.dept_id) {
        if(this.isShowCusDept){
          parameters['customer_dept_name'] = this.formAdd.userDept.name;
          parameters['customer_dept_id'] = this.formAdd.userDept.dept_id;
        }
      }
    } else {
      parameters['company_id'] = UserModule.getCompanyId;
      parameters['customer_user_id'] = UserModule.getUserId;
      parameters['customer_user_name'] = UserModule.getUserName;
    }
    if (!this.servicer || !this.servicer.servicer_company_id) {
      this.showErrorMsg('请选择服务方');
      return;
    }
    parameters['servicer_company_id'] = this.servicer.servicer_company_id;
    parameters['servicer_company_name'] = this.servicer.name;

    if (!(this.formAdd.servicerDept && this.formAdd.servicerDept.dept_id) && this.isMustSerDept) {
      this.showErrorMsg('请选择' + this.placeHolderSerDept);
      return;
    }
    if (this.formAdd.servicerDept) {
      //20230824修复如果维修部门被禁用 维修方只有一个部门 目前是默认传  修复为 如果是禁用  不传任务部门
      if(this.isShowSerDept){
        parameters['servicer_dept_id'] = this.formAdd.servicerDept.dept_id;
        parameters['servicer_dept_name'] = this.formAdd.servicerDept.name;
      }
    }
    if (!(this.selectTagArray && this.selectTagArray.length > 0) && this.isMustTag) {
      this.showErrorMsg('请添加' + this.placeholderTag);
      return;
    }
    if (this.selectTagArray && this.selectTagArray.length > 0) {
      let array:any = [];
      for (let i = 0; i < this.selectTagArray.length; i++) {
        let item = this.selectTagArray[i];
        let dic = {
          'tags_name': item.tags_name,
          'tags_id': item.tags_id
        };
        array.push(dic);
      }
      parameters['tags'] = JSON.stringify(array);
    }
    // 故障现象
    let faultTypeBean:any = {};
    if (this.formAdd.faultPhenomenonParent && this.formAdd.faultPhenomenonParent.id) {
      faultTypeBean.p_fault_type_name = this.formAdd.faultPhenomenonParent.name;
      faultTypeBean.p_fault_type_id = this.formAdd.faultPhenomenonParent.id;
    }
    if (this.formAdd.faultPhenomenon && this.formAdd.faultPhenomenon.id) {
      faultTypeBean.fault_type_name = this.formAdd.faultPhenomenon.name;
      faultTypeBean.fault_type_id = this.formAdd.faultPhenomenon.id;
    }
    if (this.formAdd.faultPhenomenonChild && this.formAdd.faultPhenomenonChild.id) {
      faultTypeBean.c_fault_type_name = this.formAdd.faultPhenomenonChild.name;
      faultTypeBean.c_fault_type_id = this.formAdd.faultPhenomenonChild.id;
    }
    if ((!faultTypeBean || !faultTypeBean.p_fault_type_id) && this.isMustFaultType) {
      this.showErrorMsg('请添加' + this.placeholderFaultType);
      return;
    }
    if (faultTypeBean && faultTypeBean.p_fault_type_id) {
      let arrayfault = [];
      arrayfault[0] = faultTypeBean;
      let strFault = JSON.stringify(arrayfault);
      parameters['fault_phenomenon'] = strFault;
    }
    let troubleDes = '';
    let num = 0;
    if (this.formAdd.description) {
      num = num + 1;
      troubleDes = num + '、' + this.formAdd.description + ';';
    }
    this.dynamicDescription.forEach(des => {
      if (des.value) {
        num = num + 1;
        troubleDes = troubleDes + num + '、' + des.value + ';';
      }
    });
    if (!(troubleDes && troubleDes.length > 0) && this.isMustDescription) {
      this.showErrorMsg('请输入' + this.placeHolderDescription);
      return;
    }
    if (this.isShowDescription) {
      parameters['trouble_describle'] = troubleDes;
    }

    if (parseInt(this.addrssType) === 3) {
      // 自定义地址
      if (!(this.formAdd.area) && this.isMustAddressSelf) {
        this.showErrorMsg('请选择' + this.placeHolderAddress);
        return;
      }
      parameters['address_id'] = this.addressId;
      parameters['one_address_id'] = this.oneAddressId;
      parameters['one_address_name'] = this.oneAddress;
      parameters['two_address_id'] = this.twoAddressId;
      parameters['two_address_name'] = this.twoAddress;
      parameters['three_address_id'] = this.threeAddressId;
      parameters['three_address_name'] = this.threeAddress;
    } else if (parseInt(this.addrssType) === 1) {
      if (!this.formAdd.area && this.isMustAddressPca) {
        this.showErrorMsg('请选择' + this.placeHolderAddress);
        return;
      }
      parameters['province_name'] = this.provinceName;
      parameters['city_name'] = this.cityName;
      parameters['district_name'] = this.districtName;
      parameters['province'] = this.province;
      parameters['city'] = this.city;
      parameters['district'] = this.district;
      parameters['address_id'] = this.addressId;
    }
    if (this.isShowAddress) {
      if (this.isMustAddress && !this.formAdd.addressDetail) {
        this.showErrorMsg('请选择或输入' + this.placeHolderAddressDetail);
        return;
      }
      parameters['address'] = this.formAdd.addressDetail;
    }

    if (!this.formAdd.name && this.isMustContentUser) {
      this.showErrorMsg('请输入' + this.placeHolderContentUser);
      return;
    }
    if (this.formAdd.name) {
      if (this.formAdd.name.length < 2 && this.formAdd.name.length > 10) {
        this.showErrorMsg('请输入2-10位' + this.placeHolderContentUser);
        return;
      }
    }
    if (this.isShowContentUser) {
      parameters['name'] = this.formAdd.name;
    }

    if (!(this.formAdd.mobile && this.formAdd.mobile.length > 0) && this.isMustContentUserMobile) {
      this.showErrorMsg('请输入手机号码');
      return;
    }
    if (this.formAdd.mobile && this.formAdd.mobile.length > 0) {
      if (!(this.formAdd.mobile.charAt(0) === '1' && this.formAdd.mobile.length === 11)) {
        this.showErrorMsg('请输入正确的手机号码');
        return;
      }
      if (this.isShowContentUserMobile) {
        parameters['mobile'] = this.formAdd.mobile;
      }
    }
    if (!(this.formAdd.phone_num && this.formAdd.phone_num.length > 0) && this.isMustContentUserPhone) {
      this.showErrorMsg('请输入联系电话');
      return;
    }

    if (this.formAdd.phone_num && this.formAdd.phone_num.length > 0) {
      if (!(this.formAdd.phone_num.length >= 3 && this.formAdd.phone_num.length <= 18)) {
        this.showErrorMsg('请输入3-18位联系电话,支持输入"-"、" _"');
        return;
      }
      if (this.isShowContentUserPhone) {
        parameters['phone_num'] = this.formAdd.phone_num;
      }
    }
    if (!this.isMustContentUserPhone && !this.isMustContentUserMobile && this.isShowContentUserMobile && this.isShowContentUserPhone &&
    !(this.formAdd.mobile && this.formAdd.mobile.length > 0) && !(this.formAdd.phone_num && this.formAdd.phone_num.length > 0)) {
      this.showErrorMsg('请输入手机号码 或 3-18位联系电话,支持输入"-"、" _"');
      return;
    }
    if (!(this.qiniuPicList && this.qiniuPicList.length > 0) && this.isMustPic) {
      this.showErrorMsg('请添加图片');
      return;
    }
    if (this.qiniuPicList && this.qiniuPicList.length > 0) {
      let imageString = '';
      for (let m = 0; m < this.qiniuPicList.length; m++) {
        imageString += this.qiniuPicList[m];
        if (m !== this.qiniuPicList.length - 1) {
          imageString += ',';
        }
      }
      parameters['trouble_image'] = imageString;
    }
    if (!(this.qiniuSoundList && this.qiniuSoundList.length > 0) && this.isMustSound) {
      this.showErrorMsg('请添加语音');
      return;
    }
    if (this.qiniuSoundList && this.qiniuSoundList.length > 0) {
      let arraySound:any = [];
      for (let itemSound of this.qiniuSoundList) {
        let sound = {
          'original_name': itemSound.full_path,
          'seconds': itemSound.seconds,
          'save_path': itemSound.url
        };
        arraySound.push(sound);
      }
      let strSound = JSON.stringify(arraySound);
      parameters['voice'] = strSound;
    }
    // video
    if (!(this.qiniuVideoList && this.qiniuVideoList.length > 0) && this.isMustVideo) {
      this.showErrorMsg('请添加视频');
      return;
    }
    if (this.qiniuVideoList && this.qiniuVideoList.length > 0) {
      let arrayVoice:any = [];
      for (let itemVoice of this.qiniuVideoList) {
        let Voice = {
          'original_name': itemVoice.full_path,
          'seconds': itemVoice.seconds,
          'save_path': itemVoice.url
        };
        arrayVoice.push(Voice);
      }
      let strVoice = JSON.stringify(arrayVoice);
      parameters['video'] = strVoice;
    }
    // 文档
    if (!(this.qiniuWordFileList && this.qiniuWordFileList.length > 0) && this.isMustWordFile) {
      this.showErrorMsg('请添加文档');
      return;
    }
    if (this.qiniuWordFileList && this.qiniuWordFileList.length > 0) {
      let arrayWD:any = [];
      for (let itemw of this.qiniuWordFileList) {
        let wd = {
          'original_name': itemw.name,
          'save_path': itemw.response.key
        };
        arrayWD.push(wd);
      }
      let strWD = JSON.stringify(arrayWD);
      parameters['document'] = strWD;
    }
    if (!this.productBean && this.isMustProduct) {
      this.showErrorMsg('请添加' + this.placeholderProduct);
      return;
    }
    if (this.productBean && this.productBean.brand_id) {
      let arrayproduct = [];
      arrayproduct[0] = this.productBean;
      let str = JSON.stringify(arrayproduct);
      parameters['product'] = str;
    }
    if (!this.formAdd.deviceSN && this.isMustDeviceSN) {
      this.showErrorMsg('请添加' + this.placeHolderDeviceSN);
      return;
    }
    parameters['device_sn'] = this.formAdd.deviceSN;

    if (!(this.selectDevice && this.selectDevice.length > 0) && this.isMustDevice) {
      this.showErrorMsg('请添加设备');
      return;
    }
    if (this.selectDevice && this.selectDevice.length > 0) {
      let arrayDevice:any = [];
      this.selectDevice.forEach((device:any) => {
        let dic = {
          'device_id': device.id
        };
        arrayDevice.push(dic);
      });
      let strDevice = JSON.stringify(arrayDevice);
      parameters['device'] = strDevice;
    }
    if (!this.formAdd.appointment && this.isMustAppointment && !this.appointmentDayTimestamp && !this.appointmentTimeInterval) {
      this.showErrorMsg('请选择预约时间');
      return;
    }

    parameters['appointment_day_timestamp'] = this.appointmentDayTimestamp;
    parameters['appointment_time_interval'] = this.appointmentTimeInterval;
    if (!this.formAdd.diyOne && this.isMustDiyOne) {
      this.showErrorMsg('请输入' + this.placeHolderDiyOne);
      return;
    }
    parameters['diy_one_content'] = this.formAdd.diyOne;
    if (!this.formAdd.diyTwo && this.isMustDiyTwo) {
      this.showErrorMsg('请输入' + this.placeHolderDiyTwo);
      return;
    }
    parameters['diy_two_content'] = this.formAdd.diyTwo;

    parameters['save_address'] = this.formAdd.saveAddress ? '1' : '0';

    if (this.formAdd.isSelf && (this.serDealDeptment && this.serDealDeptment.length > 0) &&
    (!this.formAdd.sendDept || !this.formAdd.sendDept.dept_id)) {
      this.showErrorMsg('请选择自己的部门');
      return;
    }
    if (this.formAdd.isSelf) {
      parameters['allot_dept_state'] = this.formAdd.isSelf ? 1 : 0;
      if (this.formAdd.sendDept) {
        parameters['allot_dept_id'] = this.formAdd.sendDept.dept_id;
        parameters['allot_dept_name'] = this.formAdd.sendDept.name;
      }
    }

    // // 保存任务描述
    // decributil.setDescribList(troubleDesLoc);
    this.requestToCreateOrder(parameters);
  }
  private isCommitBtn=true
  private requestToCreateOrder(parameters:any) {
    let _this = this;
    if (!_this.isCommitBtn) {
      return;
    }
    _this.isCommitBtn = false;
    createOrder(parameters).then(res => {
      _this.isCommitBtn = true;
      if ((res as any).limit_type && parseInt((res as any).limit_type) === 1) {
        this.$confirm((res as any).limit_msg, '报修成功', {
          confirmButtonText: '我知道了',
          showCancelButton: false,
          showClose: false,
          type: 'warning',
          center: true
        }).then(() => {
          _this.restReportData(1);
        });
      } else {
        this.$alert('', '报修成功', {
          confirmButtonText: '确定',
          showClose: false,
          showCancelButton: false,
          type: 'success',
          center: true
        }).then(() => {
          _this.restReportData(1);
        });
      }
    }).catch(error => {
      _this.isCommitBtn = true;
      if (error.code === 405119) {
        // this.setData({
        //   pcaString: '',
        //   pcaSeltString: ''
        // });
      }
      if(error.code === 405221){
        const _this = this
        this.$confirm(error.msg, '提示', {
          confirmButtonText: '去验收',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.$router.push({
            path: '/order/unconfirmed',
          });
        }).catch(() => {
              
        });
        return;
      }
      _this.showErrorMsg(error.msg);
    });
  }
  private restReportData(type:number) {
    this.initOrder(type);

    this.serDrptOptions = [];
    this.$set(this.formAdd, 'servicerDept', '');

    this.selectTagArray = [];
    this.$set(this.formAdd, 'tag', '');
    this.dynamicDescription = [];
    this.$set(this.formAdd, 'description', '');

    this.$set(this.formAdd, 'saveAddress', false);
    this.qiniuPicList = [];
    this.qiniuSoundList = [];
    this.qiniuVideoList = [];
    this.qiniuWordFileList = [];

    this.$set(this.formAdd, 'brand', '');
    this.productBean = '';

    this.$set(this.formAdd, 'device', '');
    this.selectDevice = [];

    this.$set(this.formAdd, 'appointment', '');
    this.appointmentDayTimestamp = '';
    this.appointmentTimeInterval = '';

    this.$set(this.formAdd, 'faultPhenomenonParent', '');
    this.$set(this.formAdd, 'faultPhenomenon', '');
    this.$set(this.formAdd, 'faultPhenomenonChild', '');
    this.$set(this.formAdd, 'faultPhenomenonStr', '');

    this.$set(this.formAdd, 'name', '');
    this.$set(this.formAdd, 'mobile', '');
    this.$set(this.formAdd, 'phone_num', '');
    this.$set(this.formAdd, 'addressDetail', '');

    this.$set(this.formAdd, 'diyOne', '');
    this.$set(this.formAdd, 'diyTwo', '');
    this.$set(this.formAdd, 'deviceSN', '');
  }
  // 获取报修部门
  private getReportDept(type:any) {
    let params: any = {
      user_id:UserModule.getUserId ? UserModule.getUserId : '0',
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      type: type, // type=9 查所有部门  type=2查服务部门
      size: 1000,
      page: 1,
      source_type: 1
    };
    getDepartmentList(params)
      .then((res) => {

        if (res.data) {
          if (!res.data.list || res.data.list.length < 1) {
            this.isHaveUserDept = false;
          } else if (res.data.list.length === 1) {
            this.isHaveUserDept = true;
            this.formAdd.userDeptName = res.data.list[0].name;
            this.formAdd.userDept = res.data.list[0];
          } else {
            this.isHaveUserDept = true;
          }
        }else{
          this.isHaveUserDept = false;
        }
    
      })
      .catch((err) => {
        let msg = err.msg;
      });
  }

  // 报修提示
  private noticeVisible = false
  private noticeData:any={}
  private closeNoticeHandle(val: boolean, isCleanSer:boolean) {
    if (isCleanSer) {
      this.servicer = '';
    }
    this.noticeVisible = val;
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
